/** Load optional custom elements only on pages (or new sections) that use them. */
const manifest = document.getElementById('hom-optional-components');

if (manifest) {
  /** @type {Record<string, string>} */
  const components = JSON.parse(manifest.textContent || '{}');
  const selector = Object.keys(components).join(',');
  const loading = new Set();

  /** @param {Element} element */
  const register = (element) => {
    const tag = element.localName;
    if (customElements.get(tag) || loading.has(tag)) return;
    loading.add(tag);
    import(components[tag]).catch((error) => {
      loading.delete(tag);
      console.warn(`[optional-components] Unable to load ${tag}:`, error);
    });
  };

  /** @param {Document | Element} root */
  const scan = (root) => {
    if (root instanceof Element && root.matches(selector)) register(root);
    root.querySelectorAll(selector).forEach(register);
  };

  scan(document);

  // Product/section rendering and theme-editor inserts must still upgrade the
  // same native components, even when the initial page did not contain them.
  const observer = new MutationObserver((records) => {
    for (const record of records) {
      for (const node of record.addedNodes) {
        if (node instanceof Element) scan(node);
      }
    }
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
}
